<template>
    <LaBaseDatePicker v-model="periodModel" range />
</template>

<script>
import { computed } from "vue";
import LaBaseDatePicker from "@/components/datepicker/BaseDatePicker";
import store from "@/store/store";
import {
    actionTypes as websiteDatesActionTypes,
    getterTypes as websiteDatesGetterTypes,
} from "@/store/WebsiteDates/types";
import { getterTypes as userGetterTypes } from "@/store/LoggedUser/types";
import { LS_KEYS } from "@/store/Publisher/types";
import { getDefaultPeriod } from "@/helpers/data";

export default {
    name: "LaMultiPublisherDatePicker",
    components: {
        LaBaseDatePicker,
    },
    setup() {
        const userId = computed(() => store.getters[userGetterTypes.getUserId]);

        const periodModel = computed({
            get: () => store.getters[websiteDatesGetterTypes.getPeriod] || getDefaultPeriod(),
            set: (val) => {
                store.dispatch(websiteDatesActionTypes.setWebsiteDatesToLS, {
                    period: val,
                    userId: userId.value,
                    namespace: LS_KEYS.DATES_YIELD,
                });
            },
        });

        return {
            periodModel,
        };
    },
};
</script>
